import type { AdminMe } from '../../../shared/api/models'
import { apiGet } from './transport'

export async function fetchAdminMe(signal?: AbortSignal): Promise<AdminMe> {
  return apiGet<'GET /admin/me'>('/admin/me', signal)
}
